import * as CONFIGS from '@/statics/configs.js'
import Logger from '@/statics/logger.js'
import Messaging from '@/statics/messaging.js'
import UDP from '@/statics/udp.js'
import axios from 'axios'

var messaging = new Messaging(new Logger(false));
const MAX_CONNECTION_ATTEMPTS = 3;
const ONLINE_CONNECTION_ATTEMPTS_THRESHOLD = 4;
var has_been_recently_local = false;
var local_connection_attempts = 0;
var online_connection_attempts = 0;

const HUB_MESSAGING_UTILS = {
  sendMessageToHub: function (store, messageContextObject) {
    var targetHub = store.getters.getHubByUUID(messageContextObject.hubUUID);
    if(targetHub !== -1){
      var connectionStatus = targetHub.connectionStatus;
      messageContextObject.hubIndex = targetHub.index;

      if( messageContextObject.connectionType === 'Local' ){
        console.log("sendMessageToHub messageContextObject.connectionType == 'Local'")
        return store.dispatch('sendMessageToHubLocal', messageContextObject);
      }else if (messageContextObject.connectionType === 'Online' ){
        console.log("sendMessageToHub messageContextObject.connectionType == 'Online'")
        return store.dispatch('sendMessageToHubOnline', messageContextObject);
      }else{
        if(connectionStatus.local === CONFIGS.HUB_CONNECTION_STATUS_CONNECTED){
          // console.log('sendMessageToHub connectionStatus.local == CONFIGS.HUB_CONNECTION_STATUS_CONNECTED')
          has_been_recently_local = true;
          return store.dispatch('sendMessageToHubLocal', messageContextObject);
        }else if(connectionStatus.online === CONFIGS.HUB_CONNECTION_STATUS_CONNECTED){
          // console.log('sendMessageToHub connectionStatus.online == CONFIGS.HUB_CONNECTION_STATUS_CONNECTED')
          if(has_been_recently_local){
            if (local_connection_attempts >= MAX_CONNECTION_ATTEMPTS){
              has_been_recently_local = false;
              local_connection_attempts = 0;
              online_connection_attempts = 0;
            } else if (online_connection_attempts >= ONLINE_CONNECTION_ATTEMPTS_THRESHOLD){
              online_connection_attempts = 0;
              local_connection_attempts += 1;
              console.log('check hub connection status attempt: ' + local_connection_attempts);
              store.dispatch('checkHubConnectionStatusLocal', messageContextObject.hubUUID);
            } else {
              online_connection_attempts += 1;
            }
          }
          return store.dispatch('sendMessageToHubOnline', messageContextObject);
        }else{
          console.log('sendMessageToHub connectionStatus.online else');
          return Promise.reject({hubIndex: messageContextObject.hubIndex, rejectCode: 3});
        }
      }
    }else{
      if( messageContextObject.connectionType === 'Online' ){
        console.log("sendMessageToHub messageContextObject.connectionType === 'Online'")
        return store.dispatch('sendMessageToHubOnline', messageContextObject);
      }else{
        console.log("sendMessageToHub messageContextObject.connectionType else")
        return store.dispatch('sendMessageToHubLocal', messageContextObject);
      }
    }
    
  },
  setNewHubTime: function (store, messageContextObject) {
    const epochTime = Date.now();
    store.dispatch('setHubTime', {connectionType: messageContextObject.connectionType, messagingHook: messageContextObject.messagingHook, hubUUID: messageContextObject.hubUUID, bodyContent: {
        dateStamp: Math.floor(epochTime / 86400000),
        timeStamp: epochTime % 86400000
      }})
        .then(response => {
          store.dispatch('sendMessageToHubLocal', messageContextObject)
        }).catch(response => {
    });
  },
  sendMessageToHubLocal: function (store, messageContextObject) {
    return new Promise(function (resolve, reject) {
      var targetHub = store.getters.getHubByUUID(messageContextObject.hubUUID);
      if(targetHub != -1){
        messageContextObject.networkAddress = targetHub.networkAddress;
        var createdMessageObject = messageContextObject.messagingHook.createHubMessage(messageContextObject);
        axios.create().post('/', 'p=' + createdMessageObject.message, {
          baseURL: messageContextObject.networkAddress,
          timeout: CONFIGS.apiTimeOut,
        }).then(response => {

          if(messageContextObject.bodyContent.psk){
            messageContextObject.messagingHook.setEncryptionPSK(messageContextObject.bodyContent.psk);
          }
          messageContextObject.response = response.data;
          messageContextObject.dueResponsePacketType = createdMessageObject.messageType;
          messageContextObject.messagingHook.processReceivedMessage(messageContextObject).then(hubResponse => {
            hubResponse.hubIndex = messageContextObject.hubIndex;
            // console.log("sendMessageToHubLocal / response => ",response)
            resolve(hubResponse);
          }).catch( (error) => {
            if (error === 2){
              store.dispatch('setNewHubTime', messageContextObject)
            } else {
              console.log("sendMessageToHubLocal1 / catch => ",error)
              reject({hubIndex: messageContextObject.hubIndex, rejectCode: 1})
            }
          })
        }).catch( (resp) => {
          console.log(resp)
          reject({hubIndex: messageContextObject.hubIndex, rejectCode: 2})
        });
      }else{
        store.dispatch('resolveHubAddress', messageContextObject.hubUUID)
        .then( response => {
          
          var createdMessageObject = messageContextObject.messagingHook.createHubMessage(messageContextObject);
          axios.create().post('/', 'p=' + createdMessageObject.message, {
            baseURL: response.networkAddress,
            timeout: CONFIGS.apiTimeOut,
          }).then(response => {
            if(messageContextObject.bodyContent.psk){
              messageContextObject.messagingHook.setEncryptionPSK(messageContextObject.bodyContent.psk);
            }
            messageContextObject.response = response.data;
            messageContextObject.dueResponsePacketType = createdMessageObject.messageType;
            messageContextObject.messagingHook.processReceivedMessage(messageContextObject).then(hubResponse => {
              // console.log("sendMessageToHubLocal / response => ",response)
              hubResponse.hubIndex = messageContextObject.hubIndex;
              resolve(hubResponse);
            }).catch( (error) => {
              if (error === 2){
                store.dispatch('setNewHubTime', messageContextObject)
              } else {
                console.log("sendMessageToHubLocal2 / catch => ",error);
                reject({hubIndex: messageContextObject.hubIndex, rejectCode: 1})
              }
            })
          }).catch( (resp) => {
            console.log("sendMessageToHubLocal / catch => ",resp)
            reject({hubIndex: messageContextObject.hubIndex, rejectCode: 2})
          });
        })
        .catch( (response) => {
          reject({hubIndex: response.hubIndex, rejectCode: 2})
        })
      }
    });
  },
  sendMessageToHubOnline: function (store, messageContextObject) {
    var hubAddress = CONFIGS.baseURL + 'device/' + messageContextObject.hubUUID + '/';
    // var hubAddress = "http://192.168.0.105:80/"
    // var hubAddress = "http://93.118.148.85:49215/"
    var createdMessageObject = messageContextObject.messagingHook.createHubMessage(messageContextObject);
    var messageToSend = {
      user_uuid: store.state.user.uuid.toString(),
      aux_auth_token: store.state.user.loginToken,
      packet: createdMessageObject.message,
    }

    // console.log("<start sending>")
    return new Promise(function (resolve, reject) {
      axios.create().post('', JSON.stringify(messageToSend), {
        // axios.create().post('/', 'p=' + createdMessageObject.message, {
        baseURL: hubAddress,
        timeout: CONFIGS.apiTimeOut,
      }).then(response => {
        if(response.data.status == 'success'){
          if(messageContextObject.bodyContent.psk){
            messageContextObject.messagingHook.setEncryptionPSK(messageContextObject.bodyContent.psk);
          }
          messageContextObject.response = response.data.response;
          messageContextObject.dueResponsePacketType = createdMessageObject.messageType;
          messageContextObject.messagingHook.processReceivedMessage(messageContextObject).then(hubResponse => {
            hubResponse.hubIndex = messageContextObject.hubIndex;
            resolve(hubResponse);
          }).catch( (error) => {
            if (error === 2){
              store.dispatch('setNewHubTime', messageContextObject)
            } else {
              reject({hubIndex: messageContextObject.hubIndex, rejectCode: 1})
            }
          })
        }else{
          reject({hubIndex: messageContextObject.hubIndex, rejectCode: 1})
        }
      }).catch( (response) => {
        // console.log("<end sending: catch>")
        reject({hubIndex: messageContextObject.hubIndex, rejectCode: 2})
      });
    })
  },
  resolveHubAddress: function(store, hubUUID) {
    return new Promise(function(resolve, reject) {
      var hub = store.getters.getHubByUUID(hubUUID);
      // window.alert(CONFIGS.APP_MODE);
      if(CONFIGS.APP_MODE != "phonegap"){
        console.log('resolveHubAddress / web => ',CONFIGS.APP_MODE);
        if(!hub.staticIp){
          var resolvedHubAddress = 'http://' + CONFIGS.DEFAULT_HUB_ADDRESS_PREFIX + messaging.utility.uuidToHexString(hubUUID).toLowerCase() + '.local';
          resolve({
            hubIndex: hub.index,
            networkAddress: resolvedHubAddress
          });
        }else{
          // window.alert(hub.ipAddress);
          console.log("resolvehubaddress, uuid is ", hubUUID);
          console.log("resolvehubaddress, static ip ", hub.ipAddress);
          resolve({
            hubIndex: hub.index,
            networkAddress: 'http://' + hub.ipAddress // + ':' + hub.port
          });
        }
      }else{
        console.log('resolveHubAddress / phone => ',CONFIGS.APP_MODE);
        if(!hub.staticIp){
          var udpProbe = new UDP(new Logger(false));
          console.log("resolvehubaddress, uuid is ", hubUUID)
          udpProbe.findHub(hubUUID, function (hubIP) {//successCB
            var resolvedHubAddress = 'http://' + hubIP;
            console.log('resolvedHubAddress => ', resolvedHubAddress);
            resolve({
              hubIndex: hub.index,
              networkAddress: resolvedHubAddress,
            });
          }, function () {//failCB
            reject({
              hubIndex: hub.index,
            })
          })
        }else{
          console.log("resolvehubaddress, uuid is ", hubUUID);
          console.log("resolvehubaddress, static ip ", hub.ipAddress);
          // window.alert(hub.ipAddress);
          resolve({
            hubIndex: hub.index,
            networkAddress: 'http://' + hub.ipAddress + ':' + hub.port
          });
        }
        
      }
    });
  },
}
export default HUB_MESSAGING_UTILS;